import { vehicleTypes } from './vehicleTypes';
/* eslint max-lines: 0 */
export const tablesHeaders = {
  [vehicleTypes.Motorbike]: {
    my_bets: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      zip_code: true,
      value: true,
    },
    new_bets: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      zip_code: true,
      value: true,
    },
    offers_sent: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      contract: true,
      value: true,
    },
    lost_auctions: {
      score: false,
      brand: false,
      model: true,
      first_registration: false,
      id: false,
    },
    browse: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      total_mileage: true,
      zip_code: true,
      bets: true,
    },
    in_realization: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      zip_code: true,
      value: true,
      pick_up_date: true,
    },
    accepted: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      value: true,
      archived: true,
    },
    sold: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      value: true,
      archived: true,
    },
    other: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      value: true,
      archived: true,
    },
    invoices: {
      display_number: true,
      id: false,
      brand: true,
      model: true,
      commission: true,
      created_at: true,
    },
    ads: {
      score: false,
      brand: true,
      model: true,
      first_registration: true,
      total_mileage: true,
      price: true,
      buttons: false,
    },
    buy_now: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      total_mileage: true,
      zip_code: true,
      bets: false,
    },
  },
  [vehicleTypes.AgriculturalMachine]: {
    my_bets: {
      score: true,
      brand_name: true,
      category: true,
      production_year: true,
      id: false,
      zip_code: true,
      value: true,
    },
    new_bets: {
      score: true,
      brand_name: true,
      category: true,
      production_year: true,
      id: false,
      zip_code: true,
      value: true,
    },
    offers_sent: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      contract: true,
      value: true,
    },
    lost_auctions: {
      score: false,
      brand: false,
      model: true,
      first_registration: false,
      id: false,
    },
    browse: {
      score: true,
      brand_name: true,
      category: true,
      production_year: true,
      meter: true,
      zip_code: true,
      bets: true,
    },
    in_realization: {
      score: true,
      brand_name: true,
      category: true,
      production_year: true,
      id: false,
      zip_code: true,
      value: true,
      pick_up_date: true,
    },
    accepted: {
      score: true,
      brand_name: true,
      category: true,
      production_year: true,
      id: false,
      value: true,
      archived: true,
    },
    sold: {
      score: true,
      brand_name: true,
      category: true,
      production_year: true,
      id: false,
      value: true,
      archived: true,
    },
    other: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      value: true,
      archived: true,
    },
    invoices: {
      display_number: true,
      id: false,
      brand: true,
      model: true,
      commission: true,
      created_at: true,
    },
    ads: {
      score: false,
      brand: true,
      model: true,
      first_registration: true,
      total_mileage: true,
      price: true,
      buttons: false,
    },
    buy_now: {
      score: true,
      brand_name: true,
      category: true,
      production_year: true,
      meter: true,
      zip_code: true,
      bets: true,
    },
  },
  [vehicleTypes.Camper]: {
    my_bets: {
      score: true,
      body_mark: true,
      model: true,
      first_registration: true,
      id: false,
      zip_code: true,
      value: true,
    },
    new_bets: {
      score: true,
      body_mark: true,
      model: true,
      first_registration: true,
      id: false,
      zip_code: true,
      value: true,
    },
    offers_sent: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      contract: true,
      value: true,
    },
    lost_auctions: {
      score: false,
      brand: false,
      model: true,
      first_registration: false,
      id: false,
    },
    browse: {
      score: true,
      body_mark: true,
      model: true,
      first_registration: true,
      total_mileage: true,
      zip_code: true,
      bets: true,
    },
    in_realization: {
      score: true,
      body_mark: true,
      model: true,
      first_registration: true,
      id: false,
      zip_code: true,
      value: true,
      pick_up_date: true,
    },
    accepted: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      value: true,
      archived: true,
    },
    sold: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      value: true,
      archived: true,
    },
    other: {
      score: true,
      brand: true,
      model: true,
      first_registration: true,
      id: false,
      value: true,
      archived: true,
    },
    invoices: {
      display_number: true,
      id: false,
      brand: true,
      model: true,
      commission: true,
      created_at: true,
    },
    ads: {
      score: false,
      brand: true,
      model: true,
      first_registration: true,
      total_mileage: true,
      price: true,
      buttons: false,
    },
    buy_now: {
      score: true,
      body_mark: true,
      model: true,
      first_registration: true,
      total_mileage: true,
      zip_code: true,
      bets: false,
    },
  },
};
